// @spec VUL-STR-064
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { SOC2CompliancePage } from '@/features/vulnerabilities/pages/SOC2CompliancePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/soc2-compliance')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.soc2VulnerabilityCompliance'),
  }),
  component: SOC2CompliancePage,
});
